import { createError } from '@common/neo.tax';

import {
  getPath,
  Path,
  RedirectState,
  useCurrentCompany,
  useFiscalYear,
  useSelectedFiscalYearIdOptional,
} from '@neo.tax/shared';

export const useFiscalYearHomeRedirect = (): RedirectState => {
  const selectedFiscalYearId = useSelectedFiscalYearIdOptional();
  if (!selectedFiscalYearId) {
    throw createError(
      'UseFiscalYearHomeRedirectError',
      'This should never happen as we should have a fiscal year id in the URL',
    );
  }
  const { company } = useCurrentCompany();
  const { fiscalYear } = useFiscalYear({ fiscalYearId: selectedFiscalYearId });

  if (!company || !fiscalYear) {
    return {
      isLoading: true,
    };
  }

  if (fiscalYear.companyId !== company.id) {
    return {
      isLoading: false,
      redirectTo: getPath({ path: Path.COMPANY, companyId: company.id }),
    };
  }

  return {
    isLoading: false,
  };
};
